// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateBlockDetailsBlock":"TaskTemplateBlockDetailsBlock__taskTemplateBlockDetailsBlock__3FY8q","info":"TaskTemplateBlockDetailsBlock__info__2AmMA","icon":"TaskTemplateBlockDetailsBlock__icon__2MFF2","bottomInfo":"TaskTemplateBlockDetailsBlock__bottomInfo__2d4nO","role":"TaskTemplateBlockDetailsBlock__role__UnQYe","roleIcon":"TaskTemplateBlockDetailsBlock__roleIcon__3_1P2"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockCard/TaskTemplateBlockDetailsBlock/TaskTemplateBlockDetailsBlock.scss
// module id = 1870
// module chunks = 0